import React from 'react';

const rules = [
  {
    title: 'Dochvilnost a vstup do lekce',
    items: [
      'Lekce začíná přesně v určený čas.',
      'Přijď prosím 5–10 minut před začátkem, abys měl/a čas se zklidnit.',
      'Po zahájení lekce již do prostoru nevstupujeme, pokud není domluveno jinak.',
      'Přesnost je součástí praxe.'
    ]
  },
  {
    title: 'Ticho a plná pozornost',
    items: [
      'Studio je místem ztišení – fyzického i mentálního.',
      'Mobilní telefony jsou vypnuté nebo v tichém režimu.',
          'Rozhovory a sdílení patří před nebo po lekci, ne během ní – výjimkou je chvíle, kdy lektor výslovně vyzve k dotazu nebo sdílení.'
    ]
  },
  {
    title: 'Permanentky a závazek k praxi',
    items: [
      'Permanentka platí po dobu 3 měsíců od zakoupení.',
      'Nevychozené lekce nepřecházejí do dalšího období.',
      'Permanentka se neprodlužuje, s výjimkou dlouhodobé nemoci, která je doložena a domluvena individuálně.',
      'Krátkodobé absence, pracovní vytížení či dovolená nejsou důvodem k prodloužení.',
      'Pravidelnost je základem účinku qigongu.'
    ]
  },
  {
    title: 'Omluvy a rušení lekcí',
    items: [
      'Z lekce se odhlaš prosím nejpozději 24 hodin předem.',
      'Při pozdějším zrušení se účtuje storno 50 % z ceny lekce.',
      'Výjimku tvoří pouze vážná nemoc, nebo hospitalizace v nemocnici, dej mi v takovém případě vědět co nejdříve.'
    ]
  },
  {
    title: 'Respekt k tělu',
    items: [
      'Každý cvičí v rámci svých možností.',
      'Bolest není cílem cvičení.',
      'Zdravotní omezení nebo aktuální potíže je nutné sdělit před lekcí.'
    ]
  },
  {
    title: 'Respekt ke skupině a vedení',
    items: [
      'Qigong je vedená praxe.',
      'Během lekce nevnášíme vlastní varianty, rady ostatním ani paralelní cvičení.',
      'Otázky a sdílení mají svůj prostor po skončení lekce.'
    ]
  }
];

export default function Rules() {
  return (
    <section className="py-20 bg-gray-900 text-gray-200 relative overflow-hidden">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-12">
          <p className="eyebrow">Společný prostor, společný respekt</p><h1 className="article-title">Pravidla studia</h1>
          <div className="w-24 h-1 gold-bg mx-auto rounded"></div>
          <p className="text-xl mt-6 text-gray-300 max-w-2xl mx-auto">
            Toto studio je prostorem vědomé praxe, klidu a soustředění.<br />
            Aby qigong mohl působit do hloubky, je potřeba jasný rámec, který chrání kvalitu cvičení i energii skupiny.
          </p>
        </div>
        <div className="space-y-10">
          {rules.map((rule, idx) => (
            <div key={idx} className="bg-gray-800 rounded-xl p-6 shadow-lg">
              <h3 className="text-2xl font-semibold mb-4 gold-text">{rule.title}</h3>
              <ul className="list-disc pl-6 space-y-2 text-lg">
                {rule.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 text-center text-lg text-gray-300">
          <hr className="my-8 border-gray-700" />
          <p>
            Tato pravidla nejsou o kontrole, ale o ochraně prostoru, ve kterém může praxe skutečně fungovat.<br />
            Jsou projevem respektu k sobě samým, ke skupině, k cestě qigongu – a také ke mně jako k tomu, kdo prostor drží a praxi vede.
          </p>
        </div>
      </div>
    </section>
  );
}
